var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bc-full-x bc-full-y"},[_c('div',{staticClass:"bc-full-x bc-full-y",staticStyle:{"background":"#000"}},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"autoplay":"","controls":"","src":_vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }